import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { useHeroMessageTest } from "../../hooks/useABTest";

const Hero = ({ heroImage }) => {
    // A/B Testing para mensaje hero
    const { variant, config, trackEvent } = useHeroMessageTest();

    const divStyle = {
        backgroundImage: `url(${heroImage})`,
        backgroundColor: "#f0f0f0"
    };

    // Manejar click en CTA
    const handleCTAClick = () => {
        trackEvent('hero_cta_click', {
            variant: variant,
            button_text: config.cta || 'Ver Promos y Precios'
        });
    };

    return (
        <>
            <div className="containerBox flexCol" style={divStyle}>
                <div className="landingContent flex flexCol alignCenter">
                    <h1>{config.title || 'Cotizá el sistema de seguridad ADT en muy pocos clicks'}</h1>
                    <p>
                        {config.subtitle || 'Recibí de forma simple las mejores opciones y packs de seguridad para tu casa o comercio y contratá tu alarma con profesionales.'}
                    </p>
                    <Link
                        to="/cotizador"
                        className="btn"
                        onClick={handleCTAClick}
                    >
                        {config.cta || 'Ver Promos y Precios'}
                    </Link>
                </div>
            </div>
            <div className="flexCol infoBox">
                <div className="stepsHome flexRow">
                    <h3>¿Cómo tener tu alarma ADT?</h3>
                    <div className="stepHomeBox flexRow">
                        <div className="stepHome">
                            <span className="stepNumber">1</span>
                            <p>Ingresas la info</p>
                        </div>
                        <div className="stepHome">
                            <span className="stepNumber">2</span>
                            <p>Recibís tu Cotización</p>
                        </div>
                        <div className="stepHome">
                            <span className="stepNumber">3</span>
                            <p>Instalamos tu Alarma</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Hero;
